import { render } from "./Button.vue?vue&type=template&id=6d78e684"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d78e684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d78e684', __exports__)) {
    api.reload('6d78e684', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=6d78e684", () => {
    api.rerender('6d78e684', render)
  })

}


export default __exports__